import { render, staticRenderFns } from "./SettingsRules.vue?vue&type=template&id=41da3848&scoped=true&"
import script from "./SettingsRules.vue?vue&type=script&lang=js&"
export * from "./SettingsRules.vue?vue&type=script&lang=js&"
import style0 from "./SettingsRules.vue?vue&type=style&index=0&id=41da3848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41da3848",
  null
  
)

export default component.exports